import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';
import { ApiService } from "src/app/services/api.service";


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.less']
})
export class ProfileComponent implements OnInit {
  
  currentUser: any = null;
  userData: any = null;
  notificationsPlatforms: any =null;
  subscription: Subscription;
  
  constructor(private dataService: DataService, private _api: ApiService,) {
  }

  ngOnInit(): void {
    let user = localStorage.getItem('user');
    this.currentUser = user;
    this.fetchData();
  }

  fetchData() {
    console.log(this.currentUser);
    this._api.get<any>(`/user/current`).subscribe(resp => {
      if (resp)
      {
        console.log(resp);    
        this.userData = resp;
      }
        }, err => {
      alert(err.message);
  });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }


}
